function validateEmail(email) {
    var re = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    return re.test(String(email).toLowerCase());
}


function validateJsFormRequire(jqueryForm, shouldShow, limitToFields = []) {
    var hasError = false;
    jqueryForm.parents('form').find('[required],.show-required').each(function (el) {
        if (!jQuery(this).val() ||
            jQuery(this).attr('type') === 'email' && !validateEmail(jQuery(this).val()) ||
            jQuery(this).hasClass('validatemail') && !validateEmail(jQuery(this).val()) ||
            jQuery(this).attr('type') === 'checkbox' && jQuery(this).prop('checked') == false) {
            jQuery(this).toggleClass('error', shouldShow);

            hasError = true;

        }
    });

    return hasError;
}


var currencyInput = document.querySelector('input[type="currency"]')
function localStringToNumber(s) {
    return Number(String(s).replace(/[^0-9.-]+/g, ""))
}
if (currencyInput != null) {
    var currency = 'HUF';
    if (localize.current_lang != 'hu') {
        currency = "EUR";
    }

    // format inital value
    onBlur({ target: currencyInput })

    // bind event listeners
    currencyInput.addEventListener('focus', onFocus)
    currencyInput.addEventListener('blur', onBlur)




    function onFocus(e) {
        var value = e.target.value;
        e.target.value = value ? localStringToNumber(value) : ''
    }

    function onBlur(e) {
        var value = e.target.value

        var options = {
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
            currency: currency,
            style: "currency",
            currencyDisplay: "symbol"
        }

        e.target.value = value
            ? localStringToNumber(value).toLocaleString(undefined, options)
            : ''
    }
}


/* Input Day */
var dayInput = document.querySelector('.js-input-day')
function localStringToNumberDay(s) {
    return Number(String(s).replace(/[^0-9.-]+/g, ""))
}
if (dayInput != null) {
    // format inital value
    onBlurDay({ target: dayInput })

    // bind event listeners
    dayInput.addEventListener('focus', onFocusDay)
    dayInput.addEventListener('blur', onBlurDay)




    function onFocusDay(e) {
        var value = e.target.value;
        if (value > 260) {
            value = 260;
        }
        e.target.value = value ? localStringToNumberDay(value) : ''
    }

    function onBlurDay(e) {
        var value = e.target.value
        if (value > 260) {
            value = 260;
        }

        e.target.value = value
            ? numberWithSpaces(localStringToNumberDay(value)) + localize.translations.day
            : ''
    }
}


/* Input person */

var personInput = document.querySelector('.js-input-person')
var personInput1 = document.querySelector('.js-input-person-1')
var personInput2 = document.querySelector('.js-input-person-2')
var personInput3 = document.querySelector('.js-input-person-3')

function localStringToNumberPerson(s) {
    return Number(String(s).replace(/[^0-9.-]+/g, ""))
}

if (personInput != null) {
    // format inital value
    onBlurPerson({ target: personInput })

    // bind event listeners
    personInput.addEventListener('focus', onFocusPerson)
    personInput.addEventListener('blur', onBlurPerson)
}

if (personInput1 != null) {
    // format inital value
    onBlurPerson({ target: personInput1 })

    // bind event listeners
    personInput1.addEventListener('focus', onFocusPerson)
    personInput1.addEventListener('blur', onBlurPerson)
}

if (personInput2 != null) {
    // format inital value
    onBlurPerson({ target: personInput2 })

    // bind event listeners
    personInput2.addEventListener('focus', onFocusPerson)
    personInput2.addEventListener('blur', onBlurPerson)
}

if (personInput3 != null) {
    // format inital value
    onBlurPerson({ target: personInput3 })

    // bind event listeners
    personInput3.addEventListener('focus', onFocusPerson)
    personInput3.addEventListener('blur', onBlurPerson)
}

function onFocusPerson(e) {
    var value = e.target.value;
    e.target.value = value ? localStringToNumberPerson(value) : ''
}

function onBlurPerson(e) {
    var value = e.target.value

    e.target.value = value
        ? numberWithSpaces(localStringToNumberPerson(value)) + localize.translations.person
        : ''
}


function numberWithSpaces(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

(function ($) {


    var hasLetterRegex = /[a-zA-Z]/;
    function removeLetters(string) {
        var r = new RegExp(hasLetterRegex, 'g');
        return string.replace(r, '');
    }

    function formatNumbers(string) {
        return removeLetters(string).replace('+', '').replace(' ', '');
    }

    $('.js-numbers-only').on("keypress keyup blur", function () {
        this.value = formatNumbers(this.value);
    });


    var lineEq = (y2, y1, x2, x1, currentVal) => {
        // y = mx + b
        var m = (y2 - y1) / (x2 - x1), b = y1 - m * x1;
        return m * currentVal + b;
    };

    var distanceThreshold = { min: 0, max: 75 };
    var opacityInterval = { from: 0, to: 1 };


    $('.js-form-submit').each(function () {
        var $that = $(this);

        new Nearby($that[0], {
            onProgress: (distance) => {
                const o = lineEq(opacityInterval.from, opacityInterval.to, distanceThreshold.max, distanceThreshold.min, distance);
                validateJsFormRequire($that, o == 1);
            }
        });
    });

    // Calculator
    $(function () {

        $(".js-calculator-form").bind("keypress", function (e) {
            if (e.keyCode == 13) {
                return false;
            }

            if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
                return false;
            }
        });
        var pagp = 0;
        $('.js-calculator-submit').on('click', function (e) {
            e.preventDefault();

            if (validateJsFormRequire($('.js-calculator-form').find('.js-form-submit'), true)) {
                return false;
            }

            var $that = $(this);
            var $buttonText = $that.data('active');

            $that.toggleClass('active');
            $('.js-number-of-employees-result').text(numberWithSpaces($('.js-number-of-employees').val()));
            $('.js-average-monthly-gross-wages-result').text(numberWithSpaces($('.js-average-monthly-gross-wages').val()));
            $('.js-average-annual-absence-result').text(numberWithSpaces($('.js-average-annual-absence').val()));

            /* éves bruttó veszteség = ([átlagbér] x 12 / 253) x [átlagos hiányzás] x [létszám] */
            var agl = (parseInt(localStringToNumber($('.js-average-monthly-gross-wages').val())) * 12 / 253) * parseInt(localStringToNumberDay($('.js-average-annual-absence').val())) * parseInt(localStringToNumberPerson($('.js-number-of-employees').val()));
            $('.js-annual-gross-loss').text(numberWithSpaces(Math.ceil(agl)));

            /* potenciális nyereség = [éves bruttó veszteség] x 0,27 */
            pagp = agl * 0.27;
            $('.js-potential-annual-gross-profit').text(numberWithSpaces(Math.ceil(pagp)));

            $('.js-calculator-results').slideToggle(function (e) {

                if ($that.hasClass('active')) {
                    $buttonText = $that.data('active');
                    $('.js-form-datas').fadeOut('200', function () {
                        $('.js-form-results').fadeIn();
                        $('html, body').animate({ scrollTop: $('.js-result-inner').offset().top - $('header').height() }, 1000);
                    });
                } else {
                    $buttonText = $that.data('default');
                    $('.js-form-results').fadeOut('200', function () {
                        $('.js-number-of-employees').val('');
                        $('.js-average-monthly-gross-wages').val('');
                        $('.js-average-annual-absence').val('');

                        $('.js-form-datas').fadeIn();
                    });
                }
                $that.val($buttonText);
            });
        });

        $('.js-calculator-getform').on('click', function (e) {
            e.preventDefault();
            $('.result-bottom').fadeOut();
            /* $('.result-top-inner').fadeOut(); */
            $('.result-top').css('border-radius', '0 0 30px 30px');
            $('.forms').fadeIn(200, function () {
                $('html, body').animate({ scrollTop: $('.js-question-forms-scroller').offset().top - $('header').height() }, 1000);
            });
        });

        var calculatorType = 1;

        $('input[type=radio][name="type"]').change(function () {
            if ($(this).val() == 0) {
                calculatorType = 0;
                $('.js-type-1').hide();
                $('.js-type-2').show();
            } else {
                calculatorType = 1;
                $('.js-type-2').hide();
                $('.js-type-1').show();
            }
        });

        $('input[type=radio][name="t1q7"]').change(function () {
            if ($(this).val() == 0) {
                $('.js-q-8').hide();
            } else {
                $('.js-q-8').show();
            }
        });

        $('.js-get-calculator-pdf').on('click', function (e) {
            e.preventDefault();

            /* TODO: validation */
            if (validateJsFormRequire($('.js-question-forms').find('.js-form-submit'), true)) {
                return false;
            }

            var urlBase = localize.pdfUrl + "?";
            var paramName = $('.js-question-forms input[name="full_name"]').val();
            var paramType = calculatorType;
            var finalUrl = "";
            if (calculatorType == 1) {
                var t1q1 = [];

                $.each($('.js-type-1 input[name="t1q1[]"]'), function (e) {
                    t1q1.push(($(this).is(':checked')) ? "1" : "0")
                });

                var paramV1 = t1q1.join();
                var paramV2 = $('.js-type-1 input[name="t1q2"]:checked').val();
                var paramV3 = $('.js-type-1 input[name="t1q3"]:checked').val();
                var paramV4 = $('.js-type-1 input[name="t1q4"]:checked').val();
                var paramV5 = $('.js-type-1 input[name="t1q5"]').val();
                var paramV6 = $('.js-type-1 input[name="t1q6"]:checked').val();
                var paramV7 = $('.js-type-1 input[name="t1q7"]:checked').val();
                var paramV8 = $('.js-type-1 input[name="t1q8"]:checked').val();
                finalUrl = urlBase + "nev=" + paramName + '&type=' + paramType + '&v1=' + paramV1 + '&v2=' + paramV2 + '&v3=' + paramV3 + '&v4=' + paramV4 + '&v5=' + paramV5 + '&v6=' + paramV6 + '&v7=' + paramV7 + '&v8=' + paramV8 + '&ny=' + Math.ceil(pagp) + '&lang=' + localize.current_lang;
            }
            if (calculatorType == 0) {
                var paramV1 = $('.js-type-2 input[name="t2q1"]:checked').val();
                var paramV2 = $('.js-type-2 input[name="t2q2"]:checked').val();
                var paramV3 = $('.js-type-2 input[name="t2q3"]:checked').val();
                var paramV4 = $('.js-type-2 input[name="t2q4"]:checked').val();
                var paramV5 = $('.js-type-2 input[name="t2q5"]:checked').val();
                var paramV6 = $('.js-type-2 input[name="t2q6"]:checked').val();
                var paramV7 = $('.js-type-2 input[name="t2q7"]:checked').val();

                finalUrl = urlBase + "nev=" + paramName + '&type=' + paramType + '&v1=' + paramV1 + '&v2=' + paramV2 + '&v3=' + paramV3 + '&v4=' + paramV4 + '&v5=' + paramV5 + '&v6=' + paramV6 + '&v7=' + paramV7 + '&ny=' + Math.ceil(pagp) + '&lang=' + localize.current_lang;
            }


            var APIURL = `https://slimmer.thisisdone.com/img?url=${encodeURIComponent(finalUrl)}&w=576&h=1170&type=pdf&quality=100%`;

            var bottom = null;
            var width = 600;

            if (window.innerWidth <= 767) {
                bottom = 0;
            }

            // SHOW SUCCESS MODAL IF NO ERROR OCCURED FOR .5 SECS
            // TODO: FIGURE OUT IF TIMEOUT IS NECESSARY
            var showSuccessModal = setTimeout(function () {
                $('.js-question-forms').trigger('reset');
                if ($('#succes-modal').length) {
                    $('#succes-modal').iziModal('destroy');
                }
                $("#succes-modal").iziModal({
                    // TODO: Add better message to title
                    title: localize.translations.success,
                    headerColor: '#5c18b9',
                    width: 600,
                    timeout: 3000,
                    timeoutProgressbar: true,
                    transitionIn: 'fadeInUp',
                    transitionOut: 'fadeOutDown',
                    pauseOnHover: false,
                    radius: 0,
                    bottom: null
                });
                $('#succes-modal').iziModal('open');
                $('.form-row-inner.ending').fadeOut();
                $('.type__wrapper.js-type-1').css('padding-bottom', '10rem');
                $('.result-top--success').delay(1000).fadeIn('fast');
            }, 500);

            $.ajax({
                url: localize.ajaxurl,
                type: 'post',
                dataType: "json",
                data: {
                    action: "generate_pdf",
                    datas: {
                        url: APIURL,
                        email: $('.js-calculator-email').val(),
                        full_name: $('.js-question-forms input[name="full_name"]').val()
                    }
                },
                success: function (response) {
                    if (!response['fault']) {
                        // $('.js-question-forms').trigger('reset');
                        // if ($('#succes-modal').length) {
                        //     $('#succes-modal').iziModal('destroy');
                        // }
                        // $("#succes-modal").iziModal({
                        //     title: response['msg'],
                        //     headerColor: '#5c18b9',
                        //     width: width,
                        //     timeout: 3000,
                        //     timeoutProgressbar: true,
                        //     transitionIn: 'fadeInUp',
                        //     transitionOut: 'fadeOutDown',
                        //     pauseOnHover: false,
                        //     radius: 0,
                        //     bottom: bottom
                        // });
                        // $('#succes-modal').iziModal('open');
                    } else {
                        // CANCEL SUCCESS TIMEOUT IF IT EXISTS
                        if (showSuccessModal) {
                            clearTimeout(showSuccessModal);
                        }

                        if ($('#error-modal').length) {
                            $('#error-modal').iziModal('destroy');
                        }

                        $("#error-modal").iziModal({
                            title: response['msg'],
                            headerColor: '#f8485e',
                            width: width,
                            timeout: 3000,
                            timeoutProgressbar: true,
                            transitionIn: 'fadeInUp',
                            transitionOut: 'fadeOutDown',
                            pauseOnHover: false,
                            radius: 0,
                            bottom: bottom
                        });
                        $('#error-modal').iziModal('open');
                    }
                }
            });
        });

        $('#reset-calculator').on('click', function () {
            $('.js-form-results').css('display', 'none');
            $('.js-form-datas').fadeIn();
            $('html, body').animate({ scrollTop: $('.calculator').offset().top - $('header').height() }, 1000);
        });
    });
})(jQuery);
